<!-- =========================================================================================
  File Name: Customer.vue
  Description: Customer customer Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card class="mb-2">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <div class="vx-col flex-1">
            <div class="w-full">
              <div class="w-full vx-row">
                <div class="vx-col w-1/5">
                  <ejs-textbox floatLabelType="Auto" placeholder="Correo electrónico" :readonly="true" v-model="data_local.email"/>
                </div>
              </div>
              <div class="w-full vx-row">
                <div class="vx-col w-full">
                  <ejs-textbox floatLabelType="Auto" placeholder="Nombre" :readonly="true" v-model="data_local.displayName"/>
                </div>
              </div>
              <div class="w-full vx-row mb-4">
                <div class="vx-col w-2/12">
                  <ejs-datepicker floatLabelType="Auto" placeholder="Fecha de nacimiento" v-model="data_local.birthdate" locale="es-GT" :readonly="true"></ejs-datepicker>
                </div>
                <div class="vx-col w-1/12">
                  <ejs-textbox floatLabelType="Auto" placeholder="Sexo" :readonly="true" v-model="data_local.gender"/>
                </div>
                <div class="vx-col w-1/12">
                  <ejs-textbox floatLabelType="Auto" placeholder="Teléfono" :readonly="true" v-model="data_local.phone"/>
                </div>
                <div class="vx-col w-2/12">
                  <ejs-textbox floatLabelType="Auto" placeholder="Proveedor de acceso" :readonly="true" v-model="data_local.providerId"/>
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>
    </vx-card>

    <vx-card v-if="loaded">
      <vs-tabs>
        <vs-tab label="Direcciones">
          <div class="flex flex-wrap items-center mt-4">
            <ejs-grid v-if="loaded" :dataSource="data_local.addresses" locale='es-GT' :toolbar='toolbarOptions' :pageSettings='pageSettings'>
              <e-columns>
                <e-column field="name" headerText="Nombre" width="200"/>
                <e-column field="address" headerText="Dirección"/>
                <e-column field="cityName" headerText="Municipio" width="200"/>
                <e-column field="stateName" headerText="Departamento" width="200"/>
                <e-column field="deliveryInstructions" headerText="Instrucciones para ubicación" width="300"/>
              </e-columns>
            </ejs-grid>
          </div>
        </vs-tab>
        <vs-tab label="Órdenes">
          <ejs-grid
            ref="grid"
            :dataSource="orders"
            locale='es-GT'
            :toolbar='toolbarOptions'
            :allowPaging="true"
            :pageSettings='pageSettings'
            :allowSorting='true'
            :sortSettings='sortOptions'
            :allowExcelExport='true'
            :toolbarClick='toolbarClick'
            :allowFiltering='true'
            :filterSettings='filterOptions'
            v-if="loaded"
          >
            <e-columns>
              <e-column field="id" headerText="ID" :isPrimaryKey="true" width="100" :template="cTemplate" displayValue="id" routeName="order" urlBase="/orders/order"/>
              <e-column field="orderNumber" headerText="Número" width="200" :template="cTemplate" displayValue="orderNumber" routeName="order" urlBase="/orders/order"/>
              <e-column field="date" headerText="Fecha" width="180" :valueAccessor="formatDate"/>
              <e-column field="address.address" headerText="Dirección de entrega"/>
              <e-column field="orderTotal" type="number" headerText="Valor" textAlign='Right' format="N2" width="130"/>
              <e-column field="status" headerText="Estado" width="150" :filter='checkBoxFilter'/>
            </e-columns>
            <e-aggregates>
              <e-aggregate>
                <e-columns>
                  <e-column type="Sum" field="orderTotal" format="N2"/>
                </e-columns>
              </e-aggregate>
            </e-aggregates>
          </ejs-grid>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
  import Vue from "vue";
  import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
  import {GridPlugin, Toolbar, Search, Aggregate} from '@syncfusion/ej2-vue-grids';
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {DatePickerPlugin} from '@syncfusion/ej2-vue-calendars';
  import CellRendererLink from '@/views/components/CRLinkS';

  import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
  import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
  import numbers from 'cldr-data/main/es-GT/numbers.json';
  import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
  import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week

  import {db} from '@/firebaseConfig';

  Vue.use(GridPlugin);
  Vue.use(TextBoxPlugin);
  Vue.use(DatePickerPlugin);

  loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);

  setCulture('es-GT');
  L10n.load({
    'es-GT': {
      'datetimepicker': {
        placeholder: 'Especifique fecha',
        today: 'Hoy'
      },
      'grid': {
        'EmptyRecord': 'No existe información relacionada con este cliente',
        'Search': 'Buscar',
        'Add': 'Agregar',
        'Edit': 'Modificar',
        'Cancel': 'Cancelar',
        'Update': 'Guardar',
        'Delete': 'Eliminar'
      }
    }
  });

  export default {
    data() {
      return {
        loaded: false,
        pageSettings: {pageSize: 10},
        pagination: [10, 25, 50, 100],
        toolbarOptions: ['Search'],
        sortOptions: {columns: [{field: 'date', direction: 'Descending'}, {field: 'id', direction: 'Descending'}]},
        cTemplate: function () {
          return {template: CellRendererLink, urlBase: '/orders/order'};
        },
        filterOptions: {
          type: 'Menu'
        },
        checkBoxFilter: {
          type: 'CheckBox'
        },
        id: '',
        data: null,
        data_local: {
          email: '',
          displayName: '',
          phone: ''
        },
        orders: [],
        id_not_found: false
      }
    },
    provide: {
      grid: [Toolbar, Search, Aggregate]
    },
    methods: {
      formatDate: function (field, data) {
        let ret = '';
        if (data[field]) {
          const d = data[field].toDate();
          ret = `${d.getDate().toString().padStart(2, '0')}/${d.getMonth().toString().padStart(2, '0')}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
        }
        return ret;
      },
      toolbarClick: function (args) {
        if (args.item.id.includes('excelexport')) {
          const excelExportProperties = {
            fileName: "ListadoÓrdenesCliente.xlsx"
          };
          this.$refs.grid.excelExport(excelExportProperties);
        }
      },
      getData(id) {
        if (id) {
          this.$vs.loading({
            text: 'Cargando información de cliente',
            type: 'point'
          });
          const self = this;
          db.collection('users')
            .doc(id)
            .get()
            .then(snapshot => {
              // self.fbId = querySnapshot.docs.data();
              self.data = snapshot.data();
              self.data_local = JSON.parse(JSON.stringify(self.data));
              if (self.data.birthdate) {
                if (typeof self.data.birthdate.toDate === 'function') {
                  self.data_local.birthdate = self.data.birthdate.toDate();
                }
              }
              self.loaded = true;
              self.$vs.loading.close();
            })
            .catch((error) => {
              self.$vs.notify({
                title: 'Error al cargar datos de cliente',
                text: error.message,
                color: 'danger'
              });
              self.$vs.loading.close();
            });
          db.collection('orders')
            .where('email', '==', id)
            .get()
            .then(querySnapshot => {
              self.orders = querySnapshot.docs.map(doc => doc.data());
            })
            .catch((error) => {
              self.$vs.notify({
                title: 'Error al cargar órdenes del cliente',
                text: error.message,
                color: 'danger'
              });
            });
        }
      }
    },

    mounted() {
      this.id = this.$route.params.id;
      this.getData(this.id);
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
  @import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
</style>
